var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "windows_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.958 14.072v51.856m14.084-51.856v51.856m14.873-33.93h-43.83m43.83 16.003h-43.83m-6.4-40.674h56.63v65.347h-56.63V7.327zm50.23 6.4v52.545H18.079V13.728h43.836z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgODAgODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMzIuOTU4MyAxNC4wNzE5VjY1LjkyODJNNDcuMDQxNSAxNC4wNzE5VjY1LjkyODJNNjEuOTE0OSAzMS45OTg5SDE4LjA4NU02MS45MTQ5IDQ4LjAwMTJIMTguMDg1TTExLjY4NDEgNy4zMjY2Nkg2OC4zMTU3VjcyLjY3MzVIMTEuNjg0MVY3LjMyNjY2Wk02MS45MTQ4IDEzLjcyNzZWNjYuMjcyNUgxOC4wNzkzVjEzLjcyNzZINjEuOTE0OFoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";
export { SvgWindows as ReactComponent };